export const CHANGE_PASSWORD_PENDING = "CHANGE_PASSWORD_PENDING";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const changePasswordPending = () => {
  return { type: CHANGE_PASSWORD_PENDING };
};

export const changePasswordSuccess = (payload) => {
  return { type: CHANGE_PASSWORD_SUCCESS, payload };
};

export const changePasswordError = (error) => {
  return { type: CHANGE_PASSWORD_ERROR, error };
};
